
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import DashboardOverview from "./DashboardOverview";
import FAQModule from "../faq/FAQModule";
import LeadsModule from "../leads/LeadsModule";
import ImagesModule from "../images/ImagesModule";
import StaticTextModule from "../static-text/StaticTextModule";
import PagesModule from "../pages/PagesModule";
import UsersModule from "../users/UsersModule";
import BlogModule from "../blog/BlogModule";
import TrialsModule from "../trials/TrialsModule";

interface MainContentProps {
  activeModule: string;
  setActiveModule: (module: string) => void;
}

const MainContent: React.FC<MainContentProps> = ({
  activeModule,
  setActiveModule,
}) => {
  const [searchParams] = useSearchParams();

  // Check for module parameter in URL when component mounts
  useEffect(() => {
    const moduleParam = searchParams.get("module");
    if (moduleParam && ["dashboard", "faq", "leads", "images", "static-text", "pages", "users", "blog", "trials"].includes(moduleParam)) {
      setActiveModule(moduleParam);
    }
  }, [searchParams, setActiveModule]);

  const renderModule = () => {
    switch (activeModule) {
      case "dashboard":
        return <DashboardOverview setActiveModule={setActiveModule} />;
      case "faq":
        return <FAQModule />;
      case "leads":
        return <LeadsModule />;
      case "images":
        return <ImagesModule />;
      case "static-text":
        return <StaticTextModule />;
      case "pages":
        return <PagesModule />;
      case "users":
        return <UsersModule />;
      case "blog":
        return <BlogModule />;
      case "trials":
        return <TrialsModule />;
      default:
        return <DashboardOverview setActiveModule={setActiveModule} />;
    }
  };

  return (
    <div className="container px-4 py-6 md:py-10 max-w-7xl mx-auto">
      {renderModule()}
    </div>
  );
};

export default MainContent;
